<template>
  <TransactionTemplate
    :headerScreenJson="getHeaderScreenJson"
    ref="invoice-activation"
    :screenJson="getScreenJson"
    :setLoading="setLoading"
    :localDataGrid="true"
    :backButtonRoute="backButtonRoute"
    :data-model="getDataModel"
    :isLoaded="loaded"
    v-if="!reload"
    :validationSummary="validationSummary"
    :serverError="serverError"
    :getHeaderToolbar="getHeaderToolbar"
    :itemPriceUpdate="itemPriceUpdate"
    :almondcoDespatchData="almondcoDespatchData"
    :gcPopupConfig="gcPopupConfig"
    class="invoice-activation"
  />
</template>

<script>
import TransactionTemplate from "../../templates/transaction";
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import { FeatureStorage } from "../../_services/storage";
import { InvoiceActivationServices } from "../../_services/api/sales/invoice-activation-services";
// import { ProductBatchService } from "../../_services/api/inventory/product-batch.service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { CompanyService } from "../../_services/api/accounts/company.service";
import { mapGetters } from "vuex";
import { getFactorByCode } from "../../_store/helpers";
import { CustomerService } from "../../_services/api/customers/customer.service";
import { CustomerAgentService } from "../../_services/api/customers/customer-agent.service";
import { formatNumber } from "devextreme/localization";
import { TaxCategoryService } from "../../_services/api/settings/accounting/tax-category.service";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";

// var BranchCode = "";
export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionTemplate,
  },
  data() {
    return {
      loaded: false,
      setLoading: false,
      reload: false,
      serverError: {},
      validationSummary: [],
      model: {
        ProcessInvoice: true,
      },
      allBatchData: [],
      itemPriceUpdate: undefined,
      processInvoiceSettingValue: undefined,
      almondcoDespatchData: undefined,
      localItems: [],
      gcPopupVisible: false,
      taxDataSourceItems: [],

      gcPopUpDataModel: {
        Code: undefined,
        SupplierName: undefined,
        InvoiceNo: undefined,
        InvoiceDate: undefined,
        DueDate: undefined,
        NewDueDate: undefined,
      },
      refSlidingScale: [],
      customerData: undefined,
      CommissionGLAccountCode: undefined,
      AgentCode: undefined,
    };
  },

  async created() {
    // BranchCode = "";
    this.setLoading = true;
    this.getProcessInvoiceSetting();
    await this.setTaxDataSourceItems();

    // await this.$store.dispatch(
    //   "defaultUserSettings/setDefaultCompanyBranchDivision"
    // );
    await this.$store.dispatch("screenFactors/getFactors", [648, 18]);

    var data = undefined;

    await InvoiceActivationServices.getByCode(this.baseView.id)
      .then(async (res) => {
        data = res;

        this.model = await this.InvoiceActivationPostProcess(res.data.value[0]);
      })
      .catch((err) => {
        if (err) this.$logger.debug("InvoiceActivationServices err ", err);
      });

    if (FeatureStorage.checkPermission("SlidingScale", "create")) {
      if (this.model) {
        await InvoiceActivationServices.getAlmondcoDespatchedSlidingScale(
          data.data.value[0].SalesOrderNo,
        )
          .then((res) => {
            this.refSlidingScale = res.data.value;
          })
          .catch((err) => {
            if (err) this.$logger.debug("refSlidingScale err ", err);
          });
        await CustomerService.getByCode(data.data.value[0].CustomerCode)
          .then((res) => {
            this.customerData = res.data.value[0];
            this.model.Customer = res.data.value[0];
          })
          .catch((err) => {
            if (err) this.$logger.debug("Customer By Code err ", err);
          });
      }
    }

    await CompanyService.getByCompanyCode(getFactorByCode(18).Factorc).then(
      (res) => {
        this.CompanyCurrency = res.data.value[0].CurrencyCode;
      },
    );

    await InvoiceActivationServices.dataSourceConfig(
      this.getDetailsEndpoint,
      this.baseView.id,
      "LineNo asc",
    )
      .then((res) => {
        this.localItems = this.PostProcess(res.data.value);
        this.localItems.forEach((element) => {
          var index = this.refSlidingScale.findIndex(
            (x) => x.ProductCode == element.ItemCode,
          );
          if (index != -1) element.SlidingScale = true;
          else element.SlidingScale = false;

          element.CheckSlidingScale = false;
          element.isNew = false;
        });
      })
      .catch((err) => {
        if (err) this.$logger.debug("InvoiceActivation err ", err);
      });

    // await ProductBatchService.getAllBatchNo()
    //   .then((res) => {
    //     this.allBatchData = res.data.value;
    this.setLoading = false;
    this.loaded = true;
    //   })
    //   .catch((err) => {
    //     this.setLoading = false;
    //     this.serverError = {
    //       err: err,
    //       msg: "despatch order failed",
    //       time: new Date().getTime(),
    //     };
    //   });
  },
  async mounted() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },
  beforeDestroy() {
    this.$store.dispatch("dataContext/setReviewDataSource", []);
  },

  computed: {
    ...mapGetters({ reviewDataSource: "dataContext/getReviewDataSource" }),
    backButtonRoute() {
      return "/pending-invoice";
    },
    getDetailsEndpoint() {
      if (
        getFactorByCode(648) &&
        getFactorByCode(648).Factorc &&
        getFactorByCode(648).Factorc == "AlmondcoGetInvoiceActivation"
      ) {
        return "AlmondcoDespatchedCustomerInvoiceDetail";
      } else return "DespatchedCustomerInvoiceDetail";
    },
    getScreenJson() {
      var screenJson = {
        title: "Invoice Activation",
        endpoint: {
          // // primary: "Invoice",
          // // filter: `Code eq ${this.baseView.id}`,
          // // expand: "SalesOrderType,SalesRepresentative,Branch,Division,Customer",
          // // expand: "Division",
          // primary: "DespatchedCustomerInvoice",
          // filter: `InvoiceNo eq ${this.baseView.id}`,
          // postProcess: this.InvoiceActivationPostProcess,
        },

        gridData: {
          gridOptions: {
            dataSource: {
              // endpoint: this.getDetailsEndpoint, //AlmondcoDespatchedCustomerInvoiceDetail
              // filter: `(CustomerInvoice eq ${this.baseView.id})`,
              // serverPaging: true,
              allowGrouping: false,
              postProcessCallback: this.PostProcess,

              localDataList: true,
              items: this.localItems,
            },
            options: {
              wordWrapEnabled: false,
              selectionMode: "none",
            },
            noDataMessage: {
              // this `review` is one of the options in the grid toolbar dropdown that represents 'Review', 'ProductList' 'CustomerList'
              review: {
                addNew: {
                  class: "add-new",
                  title: "No Order Lines",
                  message: "Get Started, Add a PO Line",
                },
              },
              addNew: {
                class: "add-new",
                title: "No Order Lines",
                message: "Get Started, Add a PO Line",
              },
            },
          },
          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: true,
            review: true,
          },
          childGridOptions: {
            visibleAutoBatch: true,
          },

          columns: [
            // {
            //   screenField: "Item",

            //   label: "Product / Account",
            //   sortOrder: "asc",
            //   gridDataField: "ItemDescription",
            //   sortIndex: 0,
            // },

            // {
            //   screenField: "Quantity",
            //   dataField: "LineNo",
            //   label: "LineNo",
            //   minWidth: 50,
            //   // visible: false,
            //   // showInColumnChooser: false,
            // },

            {
              label: "Product / Account",
              fieldTemplate: true,
              screenField: "Product",
              gridDataField: "ItemCode",
              cellTemplate: "SelectField",
              allowUpdate: true,
              // sortOrder: "asc",
              // sortIndex: 0,
              minWidth: 300,
              cssClass: "product-colunm",
              makeReadOnly: (data) => {
                if (data.data.isNew) return false;
                else return true;
              },
              displayValue: () => {
                return false;
              },
              dropDownOptions: {
                width: 300,
              },
              dataType: "string",
              dataSourceConfig: {
                endpoint: "api/InvoiceActivationProductWithGLItem",
                sort: {
                  selector: "ProductDescription1",
                  asc: true,
                },
                select: [
                  "GLChartItem",
                  "ProductCode",
                  "ProductDescription1",
                  "TaxCode",
                  "UM",
                  "ApplyCommission",
                ],
                // filter: [["Inactive", "=", "N"], "and", ["Status", "=", "A"]],
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "ProductDescription1",
                  },
                ],
                secondary: [
                  {
                    dataField: "ProductCode",
                  },
                ],
              },
              valueExpr: "ProductCode",
              displayExpr: "ProductDescription1",
              editorOptions: {
                showClearButton: true,
              },
              // showEditorAlways: true,
              // allowEditing: true,
            },
            {
              screenField: "TaxCode",
              gridDataField: "TaxCode",
              label: "Tax",
              allowEditing: false,
              showEditorAlways: false,
              allowSorting: false,
              allowSearch: false,
              cellTemplate: "SelectField",
              dataSourceConfig: {
                data: this.taxDataSourceItems,
              },
              editorTemplate: {
                primary: [
                  {
                    dataField: "Description",
                  },
                ],
                secondary: [
                  {
                    dataField: "Code",
                  },
                ],
              },
              valueExpr: "Code",
              displayExpr: "Code",
              makeReadOnly: (data) => {
                return (
                  (data.column.dataField == "TaxCode" &&
                    this.customerData &&
                    this.customerData.Gst == "Exempt") ||
                  (data.data.TaxCode == "E" && !data.data.isNew)
                );
              },
            },
            {
              screenField: "SalesUM",
              dataField: "SalesUM",
              label: "UM",
              width: 110,
              minWidth: 110,
            },
            // TODO
            {
              screenField: "SalesUMQty",
              dataField: "SalesUMOrderQty",
              label: "Ordered ",
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMQty",
              dataField: "SalesUMQty",
              label: "Invoiced ",
              format: "Decimal-16-4",
              width: ColumnWidth.Quantity4DecimalPoints.width,
              maxWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
            },
            // TODO SlidingScale
            {
              screenField: "IsDefault",
              dataField: "CheckSlidingScale",
              allowEditing: false,
              defaultValue: false,
              valueChangeCallBack: this.checkBoxValueChange,
              allowHiding: false,
              showInColumnChooser: false,
              label: "Sliding Scale",
              cellTemplate: "CheckBoxTemplate",
              // width: 50,
              minWidth: 100,
              visible: FeatureStorage.checkPermission("SlidingScale", "create"),

              makeDisabled: (data) => {
                return data.data.SlidingScale == false;
              },
            },
            {
              screenField: "SalesUMFXPrice",
              dataField: "SalesUMFXPrice",
              label: "Price(FX)",
              type: "EditableDecimal",
              format: "Decimal-16-4",
              showEditorAlways: true,
              allowSearch: false,
              allowSorting: false,
              allowFiltering: false,
              width: ColumnWidth.Price4DecimalPoints.width,
              maxWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "DiscountPercent",
              dataField: "DiscPcnt",
              label: "Discount",
            },
            {
              screenField: "SalesUMNetFXPrice",
              dataField: "SalesUMNetFXPrice",
              label: "Net (FX)",
              format: "Decimal-16-4C",
              width: ColumnWidth.Price4DecimalPoints.width,
              maxWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              screenField: "SalesUMNetFXPrice",
              dataField: "FXLineTotal",
              label: "Total",
              format: "Decimal-16-2C",
              width: ColumnWidth.Price4DecimalPoints.width,
              maxWidth: ColumnWidth.Price4DecimalPoints.minWidth,
            },
            {
              dataField: "ActionDelete",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionDelete",
              cssClass: "class-custom-btn",
              makeDisabled: (data) => {
                if (data.data.isNew) return false;
                else return true;
              },
            },
            {
              dataField: "ActionAddNew",
              label: "",
              width: 50,
              minWidth: 50,
              cellTemplate: "ActionAddNew",
              cssClass: "class-custom-btn",
            },

            {
              screenField: "GridRecordEllipsisMenu",
              allowSearch: false,
              // cssClass: "padding-7",
              ellipsisMenu: {
                itemAction: (data) => {
                  var items = [
                    {
                      menuText: "Review Sliding Scale",
                      data: data,
                      clickAction: this.enableReviewSlidingScale,
                    },
                  ];

                  return items;
                },
                keyExpr: "menuText",
                displayExpr: "menuText",
              },
              makeDisabled: (data) => {
                if (data)
                  if (
                    FeatureStorage.checkPermission("SlidingScale", "create") &&
                    data.data.SlidingScale == true
                  )
                    return false;
                  else return true;
                // return !FeatureStorage.checkPermission("SlidingScale","create") || data.data.SlidingScale == false;
              },
            },
          ],
          valueChangedEventListners: [
            {
              dataField: "ActionAddNew",
              listner: (e, lineData) => {
                this.addNewRow(e, lineData);
              },
            },
            {
              dataField: "ActionDelete",
              listner: (e, lineData) => {
                this.deleteRow(e, lineData);
              },
            },
            {
              dataField: "SalesUMFXPrice",
              listner: (e, lineData) => {
                if (lineData.data.CheckSlidingScale) {
                  lineData.data.CheckSlidingScale = false;
                  lineData.data.DiscPcnt = 0;

                  // lineData.data.SalesUMNetFXPrice = e.value;
                }
                lineData.data.SalesUMFXPrice = e.value;

                // if (lineData.data.isNew) {
                //   lineData.data.SalesUMNetFXPrice = e.value;
                // }

                lineData.data.SalesUMNetFXPrice =
                  lineData.data.SalesUMFXPrice -
                  lineData.data.SalesUMFXPrice * (lineData.data.DiscPcnt / 100);

                lineData.data.NetFXLineTotal =
                  lineData.data.SalesUMNetFXPrice * lineData.data.SalesUMQty;

                lineData.data.TaxFXLineTotal =
                  lineData.data.NetFXLineTotal * (lineData.data.TaxRate / 100);

                lineData.data.FXLineTotal =
                  lineData.data.NetFXLineTotal + lineData.data.TaxFXLineTotal;
              },
            },

            {
              dataField: "ItemCode",
              listner: (e, lineData) => {
                this.checkItemData(e, lineData);
              },
            },
            {
              dataField: "TaxCode",
              listner: (e, lineData) => {
                lineData.data.TaxCode = e.itemData.Code;
                lineData.data.TaxRate = e.itemData.Rate;
                this.updateLineValues(e, lineData);
              },
            },
          ],
        },

        footerData: {
          footerItems: [
            {
              screenField: "FXTotal",
              dataField: "FXCommissionTotal",
              label: "Commission Payable (Customer Currency)",
              location: "left",
              value: 0,
              length: 8,
              // fieldType: "custome-string",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  if (element.ApplyCommission == "Y")
                    element.FXCommissionTotal =
                      headerData.AgentCommissionPcnt *
                      ((element.NetFXLineTotal -
                        (element.NetFXLineTotal *
                          headerData.SettlementDiscountPcnt) /
                          100) /
                        100);

                  if (element.Type == "G") element.FXCommissionTotal = 0;
                  total = total + element.FXCommissionTotal.roundNumber(2);
                });
                return total;
              },
              visible: FeatureStorage.checkPermission(
                "AgentCommission",
                this.baseView.mode,
              ),
            },
            {
              dataField: "NetFXLineTotal",
              screenField: "FXTotal",
              location: "right",
              value: 0,
              label: "Sub Total (Customer Currency)",
              // format: "Decimal-16-4C",
            },
            {
              screenField: "FXTotal",
              dataField: "TaxFXLineTotal",
              location: "right",
              label: "Tax (Customer Currency)",
              value: 0,
              // format: "Decimal-16-4C",
              // customCalc: (headerData) => {
              //   return headerData.FXTaxTotal;
              // },
            },
            {
              screenField: "FXTotal",
              dataField: "Total",
              label: "Total(Customer Currency)",
              location: "right",
              value: 0,
              fieldType: "custome-string",
              customCalc: (headerData, gridItems) => {
                var total = 0;
                gridItems.forEach((element) => {
                  total =
                    total + element.NetFXLineTotal + element.TaxFXLineTotal;
                });
                return total;
              },
            },
          ],
        },
      };
      return screenJson;
    },
    getHeaderScreenJson() {
      return {
        headerData: {
          formItems: [
            {
              itemType: "group",
              caption: "",
              colCount: 3,
              items: [
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DateIn",
                      dataField: "InvoiceDate",
                      allowUpdate: false,
                      required: this.baseView.mode != "review",
                    },
                    {
                      screenField: "RequiredDate",
                      dataField: "DateDue",
                      allowUpdate: false,
                      label: {
                        text: "Due Date",
                      },
                    },
                    {
                      screenField: "CustPO",
                      dataField: "OrderNo",
                      allowUpdate: false,
                    },
                    {
                      screenField: "Agent",
                      dataField: "AgentName",
                      allowUpdate: false,
                      label: {
                        text: "Agent",
                      },
                      visible: FeatureStorage.checkPermission(
                        "AgentCommission",
                        "review",
                      ),
                    },
                    {
                      screenField: "Commission",
                      dataField: "AgentCommissionPcnt",
                      value: 0,
                      allowUpdate: this.AgentCode
                        ? true
                        : false &&
                          FeatureStorage.checkPermission(
                            "AgentCommission",
                            this.baseView.mode,
                          ),
                      visible: FeatureStorage.checkPermission(
                        "AgentCommission",
                        "review",
                      ),
                      label: {
                        text: "Commission Rate",
                      },
                      editorOptions: {
                        format: "Decimal-16-2P",
                        onValueChanged: () => {
                          this.agentCommitionPrcntOnChange();
                        },
                      },
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      screenField: "DeliverTo",
                      dataField: "DeliveryAddressCompanyName",
                      allowUpdate: false,
                    },
                    {
                      screenField: "ConNote",
                      dataField: "ConsignmentNo",
                      allowUpdate: false,
                    },
                    {
                      screenField: "Currency",
                      dataField: "Currency",
                      allowUpdate: false,
                    },
                    {
                      screenField: "ExchangeRate",
                      dataField: "ExchangeRate",
                      editorOptions: {
                        readOnly: this.CompanyCurrency === this.CurrencyCode,
                      },
                      validationRules: [
                        {
                          type: "custom",

                          validationCallback: (e) => {
                            e.rule.message = `You have entered an exchange rate of ${formatNumber(
                              e.value,
                              e.formItem.editorOptions.format,
                            )}, which is invalid. Please enter an exchange rate that is greater than 0.0000`;

                            return e.value > 0;
                          },
                        },
                      ],
                    },
                  ],
                },
                {
                  itemType: "group",
                  caption: "",
                  items: [
                    {
                      // screenField: "Branch",
                      label: {
                        text: "Branch",
                      },
                      dataField: "BranchName",
                      // allowUpdate: false,
                      editorOptions: {
                        readOnly: true,
                      },
                    },
                    {
                      screenField: "Division",
                      label: {
                        text: "Division",
                      },
                      dataField: "CompanyCode",
                      // allowUpdate: false,
                      editorOptions: {
                        readOnly: true,
                      },
                    },
                    {
                      screenField: "OrderType",
                      dataField: "SalesOrderTypeCode",
                      // allowUpdate: false,
                      editorOptions: {
                        readOnly: true,
                      },
                    },
                    {
                      screenField: "SalesRep",
                      dataField: "SalesRepresentativeFullName",
                      allowUpdate: false,
                    },
                  ],
                },
              ],
            },
          ],
          title: {
            // Credit # [CreditNote] for Invoice # [InvoiceNumber]
            createModeIsEditMode: true,
            primary: {
              primary: {
                dataField: "InvoiceNo",
                text: "Pending Invoice # ",
              },
              secondary: {
                dataField: "SalesOrderNo",
                text: " For SO #",
              },
            },
            secondary: {
              dataField: "CustomerName",
              text: undefined,
            },
          },
        },
      };
    },

    getHeaderToolbar() {
      return {
        headerToolbar: {
          // screenName: "Purchase Orders - All",
          audit: false,
          status: false,
          notes: false,
          save: FeatureStorage.checkPermission("Invoice", "edit"),
          saveCallback: this.saveInvoiceActivation,
        },
      };
    },
    getDataModel() {
      return this.model;
    },

    gcPopupConfig() {
      return {
        title: "Preview Inshell Sliding Scale Calculation",
        dataModel: this.gcPopUpDataModel,
        callBack: this.gcPopupCallBack,
        gcPopupVisible: this.gcPopupVisible,
        height: 500,
        formOptions: {
          gcLabelLocation: "left",
        },
        items: [
          {
            itemType: "group",
            caption: "",
            colCount: 1,
            items: [
              {
                dataField: "ItemDescription",
                label: {
                  text: "Product",
                },
                editorOptions: {
                  readOnly: true,
                },
              },
              {
                // screenField: "Supplier",
                dataField: "LotNo",
                label: {
                  text: "Lot#",
                },
                editorOptions: {
                  readOnly: true,
                },
              },
              {
                dataField: "SoldYield",
                label: {
                  text: "Sold Yield",
                },
                editorOptions: {
                  readOnly: true,
                },
              },
              {
                screenField: "SalesUMFXPrice",
                dataField: "SalesUMFXPrice",
                label: {
                  text: "Sale",
                },
                editorOptions: {
                  readOnly: true,
                },
              },
              {
                screenField: "SalesUMFXPrice",
                dataField: "ActualYield",
                label: {
                  text: "Actual Yield",
                },
                editorOptions: {
                  readOnly: true,
                },
              },
              {
                dataField: "SeriousDefect",
                label: {
                  text: "Serious Defect",
                },
                editorOptions: {
                  readOnly: true,
                },
                screenField: "SalesUMQty",
              },
              {
                dataField: "NetYield",
                label: {
                  text: "Net Yield",
                },
                editorOptions: {
                  readOnly: true,
                },
                screenField: "SalesUMQty",
              },
              {
                dataField: "NewSales",
                label: {
                  text: "New Sales",
                },
                editorOptions: {
                  readOnly: true,
                },
                screenField: "SalesUMQty",
              },
            ],
          },
        ],
        // save: {
        //   text: "Update",
        //   clickCallback: (e) => {
        //     this.onGcPopUpUpdate(e);
        //   },
        // },
        back: {
          text: "Back",
          clickCallback: () => {
            this.gcPopupCallBack();
          },
        },
        // option: {
        //   title: {
        //     text: "NONE",
        //     visible: false,
        //   },
        // },
      };
    },
  },
  // async beforeCreate() {
  //   await this.$store.dispatch("screenFactors/getFactors", [648, 18]);
  //   this.$store.dispatch("defaultUserSettings/setDefaultCompanyBranchDivision");
  // },
  methods: {
    async setTaxDataSourceItems() {
      let taxDS = TaxCategoryService.dataSourceConfig("api/Tax", {
        sort: {
          selector: "Description",
          asc: true,
        },
        filter: [["Inactive", "=", "N"]],
        select: ["Code,Description,Rate,WetRate"],
      });

      this.taxDataSourceItems = await taxDS.load();
    },
    async deleteRow(e, lineData) {
      let confirmLeaving = await this.$confirm(
        "Are you sure you want to delete this record ?",
        "Delete Record",
      );

      if (confirmLeaving) {
        this.localItems.splice(lineData.rowIndex, 1);
      }
    },
    calculateAmountFromFXAmount(fxAmount, exchangeRate) {
      return (
        exchangeRate == 0 ? fxAmount : fxAmount / exchangeRate
      ).roundNumber(2);
    },
    formatNumber(number) {
      return Number(parseFloat(number).toFixed(2)).toLocaleString("en", {
        minimumFractionDigits: 2,
      });
    },
    agentCommitionPrcntOnChange() {
      this.$store.dispatch(
        "dataContext/updateDataChangedIndex",
        this.dataChangedIndex++,
      );
    },
    async checkItemData(e, lineData) {
      var itemData = e.itemData;
      if (!itemData) return;

      if (this.customerData && this.customerData.Gst == "Exempt") {
        lineData.data.TaxCode = "E";
      } else {
        if (itemData.GLChartItem == "Y") lineData.data.TaxCode = "E";
        else lineData.data.TaxCode = itemData.TaxCode;
      }

      if (itemData.GLChartItem == "Y") lineData.data.Type = "G";
      else lineData.data.Type = "S";

      lineData.data.ItemCode = itemData.ProductCode;
      lineData.data.ItemDescription = itemData.ProductDescription1;
      lineData.data.SalesUM = itemData.UM;
      lineData.data.ApplyCommission = itemData.ApplyCommission;

      var rowIdx = lineData.rowIndex;
      setTimeout(() => {
        var template = this.$refs["invoice-activation"];
        if (template && template.$refs && template.$refs.transactionGrid) {
          var gridInstance = template.$refs.transactionGrid.getDataSourceInstance();
          if (gridInstance) gridInstance.editCell(rowIdx, "SalesUMFXPrice");
        }
      }, 0);

      this.setLoading = true;
      await TaxCategoryService.getByCode(lineData.data.TaxCode)
        .then((res) => {
          this.setLoading = false;
          lineData.data.TaxRate = res.data.value[0].Rate;
        })
        .catch((err) => {
          this.setLoading = false;
          if (err) lineData.data.TaxRate = 0;
        });

      // lineData.data.SalesUMNetFXPrice =
      //   lineData.data.SalesUMFXPrice -
      //   lineData.data.SalesUMFXPrice * (lineData.data.DiscPcnt / 100);

      lineData.data.NetFXLineTotal =
        lineData.data.SalesUMNetFXPrice * lineData.data.SalesUMQty;

      lineData.data.TaxFXLineTotal =
        lineData.data.NetFXLineTotal * (lineData.data.TaxRate / 100);

      lineData.data.FXLineTotal =
        lineData.data.NetFXLineTotal + lineData.data.TaxFXLineTotal;
    },

    async updateLineValues(e, lineData) {
      lineData.data.NetFXLineTotal =
        lineData.data.SalesUMNetFXPrice * lineData.data.SalesUMQty;

      lineData.data.TaxFXLineTotal =
        lineData.data.NetFXLineTotal * (lineData.data.TaxRate / 100);

      lineData.data.FXLineTotal =
        lineData.data.NetFXLineTotal + lineData.data.TaxFXLineTotal;
    },
    enableReviewSlidingScale(e) {
      this.gcPopUpDataModel = e;

      this.gcPopUpDataModel.NetYield = e.ActualYield - e.SeriousDefect;
      this.gcPopUpDataModel.NewSales =
        (e.SalesUMFXPrice / e.SoldYield) * this.gcPopUpDataModel.NetYield;
      this.gcPopupVisible = true;
    },
    gcPopupCallBack() {
      this.gcPopupVisible = false;
    },

    async addNewRow(e, lineData) {
      if (!e) return;
      this.localItems.splice(
        lineData.rowIndex + 1,
        0,
        this.PostProcess([
          {
            ActualYield: 0,
            CustomerInvoice: undefined,
            FXLineTotal: 0,
            IsPrimeCostItem: false,
            ItemCode: undefined,
            ItemDescription: undefined,
            LineNo: 0,
            LotNo: null,
            SalesUM: undefined,
            SalesUMFXPrice: 0,
            SalesUMNetFXPrice: 0,
            SalesUMQty: 1,
            SalesUMOrderQty: 1,
            SeriousDefect: 0,
            SoldYield: 0,
            SPDISC: 0,
            STAXCD: undefined,
            STAXRT: undefined,
            Type: undefined,
            isNew: true,
            CheckSlidingScale: false,
            SlidingScale: false,
            TaxRate: 0,
            NetFXLineTotal: 0,
          },
        ])[0],
      );
    },
    async getProcessInvoiceSetting() {
      await SettingsService.getBySettingName("ProcessInvoiceToggle").then(
        (res) => {
          if (res.data.value.length > 0) {
            this.processInvoiceSettingValue = res.data.value[0].SettingValue;
          }
        },
      );
    },
    checkBoxValueChange(fieldData, recordData) {
      recordData.data.CheckSlidingScale = fieldData.value;

      if (fieldData.value) {
        recordData.data.defaultDiscPcnt = recordData.data.DiscPcnt;
        recordData.data.defaultSalesUMNetFXPrice =
          recordData.data.SalesUMNetFXPrice;

        var NetYield =
          recordData.data.ActualYield - recordData.data.SeriousDefect;
        var NewSales = (
          (recordData.data.SalesUMFXPrice / recordData.data.SoldYield) *
          (NetYield ? NetYield : 0)
        ).roundNumber(2);

        recordData.data.SalesUMNetFXPrice = NewSales ? NewSales : 0;

        recordData.data.DiscPcnt =
          ((recordData.data.SalesUMFXPrice -
            recordData.data.SalesUMNetFXPrice) /
            recordData.data.SalesUMFXPrice) *
          100;
        recordData.data.FXLineTotal =
          recordData.data.SalesUMNetFXPrice * recordData.data.SalesUMQty;
      } else {
        recordData.data.DiscPcnt = recordData.data.defaultDiscPcnt;
        recordData.data.SalesUMNetFXPrice =
          recordData.data.defaultSalesUMNetFXPrice;
        recordData.data.FXLineTotal =
          recordData.data.SalesUMNetFXPrice * recordData.data.SalesUMQty;
      }
    },

    async saveInvoiceActivation(data, gridItems) {
      this.validationSummary = [];
      let InvoiceActivationInvoiceDetailCol = gridItems.map((gridItem) => {
        let InvoiceActivationInvoiceDetail = {
          RecordID: "",
          CreatedBy: "",
          ChangedBy: "",
          DateCreated: Date.Now,
          DateChanged: Date.Now,
          DATECHANGED: Date.Now,
          DATECREATED: Date.Now,
          CHANGEDBY: "",
          CREATEDBY: "",
          ActualYield: 0,
          FXLineTotal: gridItem.FXLineTotal,
          InvoiceNumber: data.InvoiceNo,
          IsPrimeCostItem: false,
          LineNo: gridItem.LineNo,
          LotNo: gridItem.LotNo ? gridItem.LotNo : 0,
          NetFXLineTotal: 0.0,
          PROMOTIONID: 0,
          PROMOTIONPRICE: 0,
          PROMOTIONTYPE: "",
          SalesOrderNo: data.SalesOrderNo,
          // DateTime: Date.Now,
          SalesUMNetFXPriceOriginal: 0.0,
          SeriousDefect: gridItem.SeriousDefect ? gridItem.SeriousDefect : 0,
          SoldYield: gridItem.SoldYield,
          SPDISC: gridItem.DiscPcnt,
          STAXCD: gridItem.TaxCode,
          STAXRT: gridItem.TaxRate,
          StockUMPromotionNetPrice: 0,
          TaxFXLineTotal: 0,
          Type: gridItem.Type,
          AllowNew: false,
          IsNew: gridItem.isNew ? true : false,
          IsDeleted: false,
          TargetTable: "",
          FriendlyName: "",
          DefaultSchema: "",
          HasChanged: gridItem.isNew ? true : false,
          Text: "",
          BranchCode: data.BranchCode,
          CompanyCode: data.CompanyCode,
          CustomerCode: data.CustomerCode,
          ItemCode: gridItem.ItemCode,
          SalesUM: gridItem.SalesUM,
          SalesUMFXPrice: gridItem.SalesUMFXPrice,
          SalesUMNetFXPrice: gridItem.SalesUMNetFXPrice,
          SalesUMQty: gridItem.SalesUMQty,
          FXCommissionTotal: gridItem.FXCommissionTotal,
          CommissionTotal: this.calculateAmountFromFXAmount(
            gridItem.FXCommissionTotal,
            data.ExchangeRate,
          ),
        };
        return InvoiceActivationInvoiceDetail;
      });

      let InvoiceActivationInvoiceHeader = {
        RecordID: "",
        CreatedBy: "",
        ChangedBy: "",
        DateCreated: Date.Now,
        DateChanged: Date.Now,
        DATECHANGED: Date.Now,
        DATECREATED: Date.Now,
        CHANGEDBY: "",
        CREATEDBY: "",
        AllowNew: false,
        IsNew: false,
        IsDeleted: false,
        TargetTable: "",
        FriendlyName: "",
        DefaultSchema: "",
        HasChanged: false,
        Text: "",
        InvoiceActivationInvoiceDetailCollection: {
          RecordID: "",
          InvoiceActivationInvoiceDetail: InvoiceActivationInvoiceDetailCol,
        },

        Include: true,
        BranchCode: data.BranchCode,
        CompanyCode: data.CompanyCode,
        CustomerCode: data.CustomerCode,
        Email: data.Email,
        EmailReadOnly: false,
        FXExTaxTotal: data.FXExTaxTotal,
        InvoiceExchangeRate: data.ExchangeRate,
        FXIncTaxTotal: data.FXIncTaxTotal,
        InvoiceDate: data.InvoiceDate,
        InvoiceNumber: data.InvoiceNo,
        SalesOrderNo: data.SalesOrderNo,
        FXTaxTotal: data.FXTaxTotal,
        CustomerAgentCode: data.AgentCode,
        CommissionPcnt: data.AgentCommissionPcnt ? data.AgentCommissionPcnt : 0,
        CommissionGLAccountCode: this.CommissionGLAccountCode,
      };
      let InvoiceActivationSalesOrder = {
        InvoiceActivationInvoiceHeaderCollection: {
          RecordID: "",
          InvoiceActivationInvoiceHeader: InvoiceActivationInvoiceHeader,
        },
        AllowNew: false,
        IsNew: false,
        IsDeleted: false,
        TargetTable: "",
        FriendlyName: "",
        DefaultSchema: "",
        HasChanged: false,
        Text: "",
        RecordID: "",
        CreatedBy: "",
        ChangedBy: "",
        DateCreated: Date.Now,
        DateChanged: Date.Now,
        DATECHANGED: Date.Now,
        DATECREATED: Date.Now,
        CHANGEDBY: "",
        CREATEDBY: "",
        CustomerName: data.CustomerName,
        Currency: data.Currency,
        CustomerCode: data.CustomerCode,
        RepCode: data.RepCode,
        SalesOrderNo: data.SalesOrderNo,
        ExchangeRate: data.ExchangeRate,
      };
      let InvoiceActivation = {
        CreatedBy: "",
        RecordID: "",
        ChangedBy: "",
        CHANGEDBY: "",
        CREATEDBY: "",
        DateCreated: Date.now,
        DateChanged: Date.now,
        DATECHANGED: Date.now,
        DATECREATED: Date.now,
        AllowNew: false,
        IsNew: false,
        IsDeleted: false,
        TargetTable: "",
        FriendlyName: "",
        DefaultSchema: "",
        HasChanged: false,
        Text: "",
        DespatchDate: Date.Now,
        RepCode: data.RepCode,
        CustomerCode: data.CustomerCode,
        InvoiceActivationSalesOrderCollection: {
          RecordID: "",
          InvoiceActivationSalesOrder: [InvoiceActivationSalesOrder],
        },
      };
      this.setLoading = true;
      await InvoiceActivationServices.saveInvoiceActivation(InvoiceActivation)
        .then((res) => {
          if (res) this.setLoading = false;

          this.$notify(
            `Invoice Activation ${this.baseView.id} saved successfully`,
            "success",
          );

          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            path: `/pending-invoice`,
          });
        })
        .catch((error) => {
          this.serverError = {
            err: error,
            msg: "Invoice Activation save failed",
            time: new Date().getTime(),
          };

          this.setLoading = false;
        });
    },
    popUpCallBack(updated) {
      this.setLoading = false;
      this.$store.dispatch("dataContext/setAllowDataContext", true);
      if (this.itemPriceUpdate) this.itemPriceUpdate.visible = false;
      this.almondcoDespatchData = undefined;
      if (updated)
        this.$refs["despatch-order"].$refs["transactionGrid"].gridRepaint();
      // dispatchDataSource.load().then(() => {
      //   this.dispatchDataSourceConfig = this.mergeDespatchOrderRecords(
      //     this.dispatchDataSourceConfig,
      //     dispatchDataSource.items()
      //   );
      // });
    },
    async InvoiceActivationPostProcess(data) {
      // let ouput = {};
      let ouput = data;
      ouput.DueDate = data.DateDue;
      ouput.CustPO = data.OrderNo;
      ouput.DeliverTo = data.DeliveryAddressCompanyName;
      ouput.ConNote = data.ConsignmentNo;
      ouput.SOType = data.SalesOrderTypeCode;
      ouput.SalesRep = data.SalesRepresentativeFullName;

      this.CurrencyCode = data.Currency;
      this.AgentCode = data.AgentCode;

      let result = await CustomerAgentService.getByCustomerCode(
        data.CustomerCode,
      );
      if (result.data.value.length > 0) {
        this.CommissionGLAccountCode =
          result.data.value[0].CommissionGLAccountCode;
      }

      return ouput;
    },
    PostProcess(data) {
      data.forEach((element) => {
        element["Code"] = element.ItemCode;
        element["Description"] = element.ItemDescription;
        element["ProductCode"] = element.ItemCode;
        element["ProductDescription1"] = element.ItemDescription;

        if (element.STAXCD != undefined) element.TaxCode = element.STAXCD;
        if (element.SPDISC != undefined) element.DiscPcnt = element.SPDISC;

        element.FXCommissionTotal = 0;

        element.TaxFXLineTotal =
          element.NetFXLineTotal * (element.TaxRate / 100);
      });
      return data;
    },
  },
};
</script>

<style lang="scss">
.invoice-activation {
  .product-colunm {
    padding-bottom: 0 !important;
  }
}
</style>
